import { API_PREFIX_PATH } from "src/constants";
import type { FetchFromApiType } from "src/hooks/api/useApiClient";
import { downloadDocument } from "src/utils/documentDownload";

export async function exportDealersToCSV(
  fetchFromApi: FetchFromApiType,
  safeApiCall: (
    apiCall: () => Promise<unknown>,
    options?: { suppressErrorRedirect?: boolean },
  ) => Promise<unknown>,
) {
  await downloadDocument(
    fetchFromApi,
    safeApiCall,
    `${API_PREFIX_PATH}/dealers/export`,
    "dealers_export.csv",
  );
}

export async function exportEmployees(
  fetchFromApi: FetchFromApiType,
  safeApiCall: (
    apiCall: () => Promise<unknown>,
    options?: { suppressErrorRedirect?: boolean },
  ) => Promise<unknown>,
) {
  await downloadDocument(
    fetchFromApi,
    safeApiCall,
    `${API_PREFIX_PATH}/dealer-employees/export`,
    "employees_export.csv",
  );
}
